<template>
  <settings-modal class="payment-cancel-modal">
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <p
      v-if="isWarningMessageVisible"
      class="subheading red--text text-darken-2 mb-0"
    >Before you confirm, make sure that a return transaction has been created.</p>

    <template slot="actions">
      <v-btn
        id="reject"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentCancelModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        isLoading: false,
        error: null
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      cancelPaymentApiRequest () {
        return new ApiRequest(
          this.payment.isPostponedSwift
            ? PaymentApi.cancelPostponedSwiftByAccountant
            : PaymentApi.cancelByAccountant
        )
      },
      payment () {
        return this.modal.data.payment
      },
      heading () {
        return `Cancel payment ${this.payment.id}?`
      },
      isWarningMessageVisible () {
        return !this.payment.hasFinTag
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.setError(null)
        this.setIsLoading(true)

        this.cancelPaymentApiRequest
          .execute(this.payment.id)
          .then(this.cancelSuccessHandler)
          .catch((error) => {
            this.setError(error)
            this.setIsLoading(false)
          })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      cancelSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully canceled.' }
          })
        }, 100)
      },
      setIsLoading (isLoading) {
        return this.$set(this, 'isLoading', isLoading)
      },
      setError (error) {
        return this.$set(this, 'error', error)
      }
    }
  }
</script>

<style lang="scss">
  .payment-cancel-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }
  }
</style>
